export const MIN_TICK_WIDTH = 52; // roughly length of "CW50", multiple of 4
// digital export supports infinite content, so we can be more generous with the space taken
export const MIN_TICK_WIDTH_DIGITAL = MIN_TICK_WIDTH * 2;
export const PPI = 96; // pixels per inch on a 20" 1920px monitor
export const DEFAULT_PRINT_MARGIN = 0.35 * PPI;
export const EXPORT_RESOURCE_MARGIN = 2;
export const EXPORT_BAR_MARGIN = EXPORT_RESOURCE_MARGIN;
export const CSS_EXPORT_WRAPPER = 'kop-pdf-export-wrapper';
export const EXPORT_CSS_EVENT_LINE_HEIGHT_VARIABLE = '--export-order-event-line-height';
